/**
 * Strip the DeepEval "GEval" marker from a metric name for display.
 * Handles " [GEval]", "[GEval]", "(G-Eval)", trailing "GEval", any casing.
 */
export function cleanMetricName(name: string): string {
  return name
    .replace(/\s*[[(]?\s*g-?eval\s*[\])]?/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trim()
}
